<template>
  <div>
    <div class="table-container" v-show="!isLoading && items.length > 0">
      <transition name="slide-up">
        <div class="infinity-loader" v-show="scrollLoading">
          <i class="fas fa-spinner fa-spin"></i> Loading
        </div>
      </transition>

      <div class="select-filter" v-if="isMobile">
        <div :class="'un-id sortable' + (isSorting ? ' disabled': '')" @click="sort('r.ID')">
          <span>ID</span>
          <span v-show="rsvpSort.order === 'r.ID'">
            <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
            <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
            <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
          </span>
        </div>
        <div :class="'un-pickup-time sortable' + (isSorting ? ' disabled': '')" @click="sort('b.pickupTime')">
          <span>Pickup Time</span>
          <span v-show="rsvpSort.order === 'b.pickupTime'">
            <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
            <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
            <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
          </span>
        </div>
      </div>


      <table @scroll="onScroll" v-show="isMobile ? !isSorting : true">
        <thead class="fixed-header" v-if="!isMobile">
          <drag tag="tr" class="table-header">
            <th class="un-check"><input type="checkbox" v-model="checkedAll" /></th>
            <th v-bind:class="'un-id sortable' + (isSorting ? ' disabled': '')" @click="sort('r.ID')">
              <span>ID</span>
              <span v-show="rsvpSort.order === 'r.ID'">
                <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <!-- <th>STATUS</th> -->
            <th v-bind:class="'un-pickup-time sortable' + (isSorting ? ' disabled': '')" @click="sort('b.pickupTime')">
              <span>PICKUP TIME</span>
              <span v-show="rsvpSort.order === 'b.pickupTime'">
                <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th v-bind:class="'un-pickup sortable' + (isSorting ? ' disabled': '')" @click="sort('puCity')">
              <span>PICKUP</span>
              <span v-show="rsvpSort.order === 'puCity'">
                <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th v-bind:class="'un-dropoff sortable' + (isSorting ? ' disabled': '')" @click="sort('doCity')">
              <span>DROP-OFF</span>
              <span v-show="rsvpSort.order === 'doCity'">
                <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th class="un-service">SERVICE</th>
            <!-- <th>PICKUP<br/>SECTORS</th>
            <th>DROP-OFF<br/>SECTORS</th> -->
            <th class="un-btt">BE THERE TIME</th>
            <!-- <th v-bind:class="'sortable' + (isSorting ? ' disabled': '')" @click="sort('CfirstName')">
              <span>CUSTOMER</span>
              <span v-show="rsvpSort.order === 'CfirstName'">
                <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th> -->
            <th class="un-flight">FLIGHT</th>
            <th class="un-ada">ADA</th>
            <th v-bind:class="'un-pax sortable' + (isSorting ? ' disabled': '')" @click="sort('b.passengers')">
              <span>PAX</span>
              <span v-show="rsvpSort.order === 'b.passengers'">
                <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th v-bind:class="'un-luggage sortable' + (isSorting ? ' disabled': '')" @click="sort('b.luggage')">
              <span>LUGGAGE</span>
              <span v-show="rsvpSort.order === 'b.luggage'">
                <i class="fas fa-caret-up" v-show="rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-caret-down" v-show="!rsvpSort.asc && !isSorting"></i>
                <i class="fas fa-spinner fa-spin" v-show="isSorting"></i>
              </span>
            </th>
            <th class="un-map"></th>
          </drag>
        </thead>
        <tbody>
          <reservation-row v-for="(rsvp, index) in items" :rsvp="rsvp" :key="index" :isMobile="isMobile"></reservation-row>
        </tbody>
      </table>

      <!-- <div v-bind:class="{ paging: true, disabled: isPageLoading }"
            v-show="totalPages > 1">
        <a v-bind:class="{
             'page page-btn back': true,
             disabled: currentPage === 1
          }" href="javascript:;" @click="pageBtn(false)">
          <i v-bind:class="{
            'fas fa-fw': true,
            'fa-chevron-left': !isLoadingBack,
            'fa-spinner fa-spin': isLoadingBack
          }"></i>
        </a>
        <select class="page page-number" v-model.number="currentPage" @change="loadPage">
          <option v-for="n in totalPages" :value="n">{{ n }}</option>
        </select>
        <a v-bind:class="{
             'page page-btn next': true,
             disabled: currentPage === totalPages
          }" href="javascript:;" @click="pageBtn(true)">
          <i v-bind:class="{
            'fas fa-fw': true,
            'fa-chevron-right': !isLoadingNext,
            'fa-spinner fa-spin': isLoadingNext
          }"></i>
        </a>
      </div> -->
    </div>

    <div class="empty-reservations" v-show="items.length <= 0 && !isLoading">
      <arrow-up></arrow-up>
      <div class="title">Oops. Looks like we found nothing.</div>
      <div class="content">
        We can't find any reservations or package for that filter.<br/>
        Please use another one from the form at the top.
      </div>
    </div>

    <div class="table-loader" v-show="isLoading">
      <ellipsis-loader></ellipsis-loader>
      <div class="loader-title">{{ $t('dispatch.rsvpTable.loadingData.title') }}</div>
      <div class="loader-text">{{ $t('dispatch.rsvpTable.loadingData.content') }}</div>
    </div>
  </div>
</template>

<script>
import ApiRoutingReservation from '@/modules/api/routing/reservations'

import ArrowUp from '@/components/Partials/LoadingAnimation/ArrowUp'
import EllipsisLoader from '@/components/Partials/LoadingAnimation/Ellipsis'
import ReservationRow from './ReservationRow'

export default {
  name: 'reservations-table',
  props: ['isMobile'],
  components: { ArrowUp, EllipsisLoader, ReservationRow },
  data () {
    return {
      isPageLoading: false,
      isLoadingNext: false,
      isLoadingBack: false,
      isSorting: false,
      scrollLoading: false
    }
  },
  computed: {
    items () { return this.$store.state.routing.reservations.items },
    isLoading () { return this.$store.state.routing.reservations.isLoading },
    totalPages () { return this.$store.state.routing.reservations.paging.totalPages },
    currentPage: {
      get () { return this.$store.state.routing.reservations.paging.currentPage },
      set (value) { this.$store.commit('routing/setReservationsCurrentPage', value) }
    },
    rsvpSort () { return this.$store.state.routing.reservations.sort },
    checkedAll: {
      get () {
        return this.$store.state.routing.reservations.items.length ===
               this.$store.state.routing.reservations.checked.length
      },
      set (value) {
        let self = this
        let rsvps = self.$store.state.routing.reservations.items
        let checkedItems = []
        if (value) {
          for (let i = 0; i < rsvps.length; i++) {
            checkedItems.push(rsvps[i].id)
          }
        }
        self.$store.commit('routing/updateCheckedReservations', checkedItems)
      }
    },
    rtgSuccess () { return this.$store.state.dispatch.readyToGo.success }
  },
  methods: {
    pageBtn (isNext) {
      let self = this
      let pageChange = isNext ? 1 : -1
      if (isNext) {
        self.isLoadingNext = true
      } else {
        self.isLoadingBack = true
      }
      self.$store.commit('routing/setReservationsCurrentPage',
        self.$store.state.routing.reservations.paging.currentPage + pageChange)
      self.loadPage()
    },
    loadPage () {
      let self = this
      // self.isPageLoading = true
      ApiRoutingReservation.getReservations(self, r => {
        // self.isPageLoading = false
        self.isLoadingBack = false
        self.isLoadingNext = false
        self.scrollLoading = false

        if (r.error) {
          return
        }

        // self.$plugins.smoothScroll.scrollTo(document.getElementById('routing-reservations-table'))
      }, true)
    },
    sort (order) {
      let self = this
      let existingOrder = self.rsvpSort.order
      let existingAsc = self.rsvpSort.asc
      let asc = existingAsc
      if (order === existingOrder) {
        asc = !existingAsc
      }

      self.$store.commit('routing/setReservationsSort', {
        order: order, asc: asc
      })

      self.isSorting = true
      self.$store.commit('routing/setReservationsCurrentPage', 1)
      ApiRoutingReservation.getReservations(self, r => {
        self.isSorting = false
        if (r.error) {
          return
        }
      }, true)
    },
    onScroll (event) {
      let rsvpPaging = this.$store.state.routing.reservations.paging
      if (this.scrollLoading || rsvpPaging.currentPage >= rsvpPaging.totalPages) { return }

      this.scrollLoading = true
      this.$store.commit('routing/setReservationsCurrentPage', rsvpPaging.currentPage + 1)
      this.loadPage()
    }
  },
  watch: {
    rtgSuccess: function (value) {
      if (value) {
        this.$store.commit('dispatch/setReadyToGoSuccess', false)
        this.loadPage()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dragslot {
  font-weight: 700;
  background-color: #fff;
  padding: 5px;
  box-shadow: 2px 0 8px rgba(0,0,0,0.25);
  border: 1px solid rgba(0,0,0,0.4);
  border-radius: 3px;
}
.table-container {
  padding: 47px 0 0;
  & input[type="checkbox"]{
    margin-top: 0;
    width: auto;
  }
  & table{
    border-collapse: collapse;
    width: 100%;
  }

  .fixed-header{
    position: absolute;
    top: 0;
  }
  & .table-header{
    color: #8DA0A9;
    font-size: 12px;
    /*border: 1px solid rgba(0,0,0,0.3);*/
    background-color: #f5f5f5;

    & th{
      padding: 5px;

      &.sortable {
        cursor: pointer;
        text-decoration: underline;
        color: #333;
        transition: all 250ms;

        &.disabled {
          pointer-events: none;
          opacity: 0.5;
        }
      }
      &.un-check{ width: 24px; }
      &.un-id, &.un-luggage{ width: 60px; }
      &.un-pickup-time, &.un-btt{ width: 75px; }
      &.un-pickup span:first-child, &.un-dropoff span:first-child{
        width: 211px;
        display: block;
      }
      &.un-flight{ width: 129px; }
      &.un-ada{ width: 46px; }
      &.un-pax{ width: 32px; }
      &.un-map{ width: 30px; }
    }
  }
}

.empty-reservations{
  max-width: 450px;
  margin: 50px auto;
  text-align: center;

  & .title {
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .content{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}

.table-loader{
  position: relative;
  width: 300px;
  margin: 50px auto;
  text-align: center;

  & .loader-title{
    font-weight: 700;
    margin-top: 20px;
    font-size: 20px;
    color: #3F2975;
  }

  & .loader-text{
    font-weight: 700;
    margin-top: 10px;
    font-size: 16px;
    color: #777;
  }
}

.paging {
  margin: 15px auto;
  width: 103px;
  opacity: 1;
  transition: all 250ms;

  &.disabled {
    pointer-events: none;
    opacity: 0.6;
  }

  & .page{
    display: inline-block;
    vertical-align: middle;
    width: auto;

    &:not(:first-child) {
      margin-left: -5px;
    }
  }

  & .page-btn {
    background-color: #f5f5f5;
    border: 1px solid rgba(0,0,0,0.25);
    color: #777;
    padding: 5px 5px;
    font-size: 12px;

    &.disabled {
      pointer-events: none;
      opacity: 0.5;
    }

    & i { line-height: inherit; }

    &.back {
      border-top-left-radius: 3px;
      border-bottom-left-radius: 3px;
      border-right: 0;
    }

    &.next {
      border-top-right-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }

  & .page-number {
    border-radius: 0;
    background-color: #fff;
    border: 1px solid rgba(0,0,0,0.3);
    line-height: inherit;
    font-size: 12px;
    margin: 0;
    width: 50px;
    font-weight: 700;
    padding: 5px 10px;
    color: #333;
    text-align: center;
    appearance: none;
    outline: 0;
    text-align-last:center;
    border-right: 0;
  }
}

.infinity-loader{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 40px;
  background: rgba(0,0,0, .6);
  color: #fff;
  transform-origin: bottom center;
  text-align: center;
  font-size: 18px;
  line-height: 40px;
}

.slide-up-enter-active, .slide-up-leave-active { transition: all .3s ease; }
.slide-up-enter, .slide-up-leave-to {
  transform: rotateX(-90deg);
  opacity: 0;
}

@media only screen and (max-width: 430px) {
  .select-filter {
    display: flex;
    margin: 0 10px;
    justify-content: center;
    .sortable {
      border: 1px solid #ccc;
      padding: 5px 20px;
      font-size: 12px;
      font-weight: 900;
      text-transform: uppercase; 
      width: 50%;
      text-align: center;
      background-color: #fff;
    }
  }
  .table-container {
    padding-top: 10px;
    padding-bottom: 50px;
  }

  .empty-reservations {
    padding: 0 10px;
    .title {
      font-size: 18px;
    }
    .content {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Routing/ReservationsTable.vue